// @flow
import type {ApplicationRedux} from 'redux/ApplicationRedux';
import type {OfferState} from 'redux/v1/reservation/offer/OfferState';
import type {SelectState} from 'redux/v1/reservation/select/SelectState';
import type {UnselectState} from 'redux/v1/reservation/unselect/UnselectState';

import {reservationState} from 'redux/v1/V1State';

export type ReservationState = {
  offer: OfferState,
  select: SelectState,
  unselect: UnselectState,
};

export const offerState = (state: ApplicationRedux): OfferState =>
  reservationState(state).offer;

export const selectState = (state: ApplicationRedux): SelectState =>
  reservationState(state).select;

export const unselectState = (state: ApplicationRedux): UnselectState =>
  reservationState(state).unselect;
